import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCol,
    IonIcon,
    IonLabel,
    IonRow,
    IonText,
    isPlatform,
} from "@ionic/react";
import React from "react";
import { add, addCircleOutline, create, createOutline } from "ionicons/icons";
import { Event } from "../../models";
import { useHistory } from "react-router";

interface _Props {
    event: Event
}

const EditEventDivisionCard: React.FC<_Props> = ({event}) => {
    const history = useHistory();

    const navigateToPage = () => {
        if (event) {
            const path = "/index/staff/event/" + event.id + "/divisions/edit";
            history.push(path);
        }
    }

    return (
        <>
            {isPlatform("mobile") ? 
                <IonButton expand="full" onClick={navigateToPage}>
                    <IonIcon icon={addCircleOutline} size="large" />
                    <IonText>Bulk Add Divisions</IonText>
                </IonButton>
                :
                <IonButton onClick={navigateToPage}>
                    <IonIcon icon={addCircleOutline} size="large" />
                    <IonText>Bulk Add Divisions</IonText>
                </IonButton>
            }
        </>
    );
};

export default EditEventDivisionCard;
